
var product_lens_comparison_swiper_top = new Swiper(".lens-cmp-swiper-top", {
  autoHeight: true,
  loop: false,
//   loopedSlides: 3,
  spaceBetween: 0,
  slidesPerView: 3,
//   centeredSlides: true,
  slideToClickedSlide: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      loop: false,
      rewind: true,
      threshold: 30,
    },
    480: {
      slidesPerView: 1,
      loop: false,
      rewind: true,
      threshold: 30,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 3,
    },
  },
});

var product_lens_comparison_swiper_bottom = new Swiper(".lens-cmp-swiper-bottom", {
  lazy: false,
  loop: false,
  allowTouchMove: false,
  spaceBetween: 0,
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  speed: 0,
  thumbs: {
    swiper: product_lens_comparison_swiper_top,
  },
  breakpoints: {
    320: {
      loop: false,
      rewind: true,
      speed: 0,
    },
    480: {
      loop: false,
      rewind: true,
      speed: 0,
    },
    768: {
    },
    1024: {
    },
  },
});

// product_lens_comparison_swiper_top.controller.control = product_lens_comparison_swiper_bottom;
// product_lens_comparison_swiper_bottom.controller.control = product_lens_comparison_swiper_top;

// Active thumb sync with main slide
product_lens_comparison_swiper_top.on('slideChange', function () {   
  var activeIndex = product_lens_comparison_swiper_top.activeIndex;
  var bottomPagination = $(".lens-cmp-swiper-bottom .swiper-pagination-bullet")[activeIndex];

  //console.log (activeIndex, $(bottomPagination).attr('aria-label'));
  $(bottomPagination).trigger('click');
});



/***************************  Product Lens Comparison ***************************/

function getOriginWidth(str) {
  var windowsize = $(window).width();

  $(window).resize(function () {
    var windowsize = $(window).width();
  });

  var color_img = $(str + ' img');
  var theImage = new Image();
  theImage.src = color_img.attr("src");

  theImage.onload = function () {
    var color_w = Math.min(theImage.width, windowsize);
    color_w -= 30; //for padding

    $(str).css({ 'width': color_w, 'margin': 'auto' });
    $(str + ' img').css({ 'width': color_w, 'max-width': color_w });
  };
}

$(document).ready(function () {
  //    get origin color_image width
//   getOriginWidth('#color0');
//   getOriginWidth('#color1');
//   getOriginWidth('#color2');

  $('.ba-slider').each(function () {
    var cur = $(this);
    // Adjust the slider
    var width = cur.width() + 'px';
    cur.find('.resize img').css('width', width);
    // Bind dragging events
    drags(cur.find('.handle'), cur.find('.resize'), cur);
  });
})

// Update sliders on resize. 
$(window).resize(function () {
  $('.ba-slider').each(function () {
    var cur = $(this);

    var width = cur.width() + 'px';
    cur.find('.resize img').css('width', width);
  });
});

function drags(dragElement, resizeElement, container) {
  // Initialize the dragging event on mousedown.
  dragElement.on('mousedown touchstart', function (e) {

    dragElement.addClass('draggable1');
    resizeElement.addClass('resizable');

    // Check if it's a mouse or touch event and pass along the correct value
    var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

    // Get the initial position
    var dragWidth = dragElement.outerWidth(),
      posX = dragElement.offset().left + dragWidth - startX,
      containerOffset = container.offset().left,
      containerWidth = container.outerWidth();

    // Set limits
    minLeft = containerOffset + 10;
    maxLeft = containerOffset + containerWidth - dragWidth - 10;

    // Calculate the dragging distance on mousemove.
    dragElement.parents().on("mousemove touchmove", function (e) {

      // Check if it's a mouse or touch event and pass along the correct value
      var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

      leftValue = moveX + posX - dragWidth;

      // Prevent going off limits
      if (leftValue < minLeft) {
        leftValue = minLeft;
      } else if (leftValue > maxLeft) {
        leftValue = maxLeft;
      }

      // Translate the handle's left value to masked divs width.
      widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

      // Set the new values for the slider and the handle. 
      // Bind mouseup events to stop dragging.
      $('.draggable1').css('left', widthValue).on('mouseup touchend touchcancel', function () {
        $(this).removeClass('draggable1');
        resizeElement.removeClass('resizable');
      });
      $('.resizable').css('width', widthValue);
    }).on('mouseup touchend touchcancel', function () {
      dragElement.removeClass('draggable1');
      resizeElement.removeClass('resizable');
    });
    e.preventDefault();
  }).on('mouseup touchend touchcancel', function (e) {
    dragElement.removeClass('draggable1');
    resizeElement.removeClass('resizable');
  });
}

/*************************  Product Lens Comparison end  ************************/

/***************************  Menu Click -> Show/Hide ***************************/

$(document).ready(function () {
  $('.menu-drawer-close-btn').click(function () {
    $('body').removeClass('overflow-hidden-mobile menu-opening');

    var details = $('header-drawer details[open]');
    setTimeout(function () {
      $(details).removeAttr('open');
      $(details).removeClass('menu-opening');
      $(details).find('summary').attr('aria-expanded', 'false');
    }, 400);
  });

  $('.header__icon--menu').click(function () {
//     $('body').addClass('overflow-hidden-mobile menu-opening');

//     var details = $('header-drawer details');
//     $(details).attr('open', '');
//     $(details).addClass('menu-opening');
//     $(details).find('summary').attr('aria-expanded', 'true');
  });

  $('#MainContent').click(function (event) {
    $('body').removeClass('overflow-hidden-mobile menu-opening');

    var details = $('header-drawer details[open]');
    setTimeout(function () {
      $(details).removeAttr('open');
      $(details).removeClass('menu-opening');
      $(details).find('summary').attr('aria-expanded', 'false');
    }, 400);
  });
  
  
  
  $(".grey-title-wrapper .menu-area").click(function () {
    $(this).closest('section').find('.page-width').slideToggle(400, "swing", null);
  });
  
  
  
  
  
  var youtube = document.querySelectorAll( ".youtube" );

  for (var i = 0; i < youtube.length; i++) {

    //var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/sddefault.jpg";
    var source = "https://i.ytimg.com/vi_webp/"+ youtube[i].dataset.embed +"/maxresdefault.webp";

    var image = new Image();
    image.src = source;
    image.setAttribute( "alt", "youtube-preview" );
    image.setAttribute( "loading", "lazy" );
    image.addEventListener( "load", function() {
      youtube[ i ].appendChild( image );
    }( i ) );

    youtube[i].addEventListener( "click", function() {

      var iframe = document.createElement( "iframe" );

      iframe.setAttribute( "frameborder", "0" );
      iframe.setAttribute( "allowfullscreen", "" );
      iframe.setAttribute( "width", "838" );
      iframe.setAttribute( "height", "478" );
      iframe.setAttribute( "loading", "lazy" );
      iframe.setAttribute( "allow", "autoplay" );
      iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&vq=720&autoplay=1" );

      this.innerHTML = "";
      this.appendChild( iframe );
    } );    
  };
  
  
  $(".product-lens-compare input").change(function(){
    $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".swiper-slide").removeClass('swiper-slide');
    var place_type = $(".product-lens-compare input[type='radio']:checked").val();
    if (place_type == "mountain") {
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".mountain").removeClass('non-swiper-slide');
      
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".desert").addClass('non-swiper-slide');
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".marine").addClass('non-swiper-slide');
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".mountain").addClass('swiper-slide');
    } else if (place_type == "desert") {
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".desert").removeClass('non-swiper-slide');
      
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".mountain").addClass('non-swiper-slide');
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".marine").addClass('non-swiper-slide');
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".desert").addClass('swiper-slide');
    } else {
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".marine").removeClass('non-swiper-slide');
      
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".desert").addClass('non-swiper-slide');
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".mountain").addClass('non-swiper-slide');
      $(".lens-cmp-swiper-bottom .swiper-wrapper").find(".marine").addClass('swiper-slide');
    }
    
    $('.' + place_type +  ' .ba-slider').each(function () {
      var cur = $(this);
      // Adjust the slider
      var width = cur.width() + 'px';
      cur.find('.resize img').css('width', width);
      // Bind dragging events
      drags(cur.find('.handle'), cur.find('.resize'), cur);
    });
    
    //$('.lens-cmp-swiper-bottom')[0].swiper.update();
  });
  
  
  /*if( typeof product_variants_removed != undefined ) {  // was there items to be removed?
    var $addToCartForm = $('form[action="/cart/add"]');
    if (window.MutationObserver) {// && $addToCartForm.length) {
    var config = { childList: true, subtree: true };
        product_variants_removed.forEach(function(item){
          console.log (item);
          $('.product-swatch-carousel input').filter(function() { return $(this).text() === item; }).prop('disabled', true);
        });    
    }
  }*/
});


// jQuery(".lens-cmp-swiper-bottom").addClass("lens-overlay");
// jQuery(".lens-cmp-swiper-bottom").hover(function () {
//     jQuery(this).removeClass("lens-overlay");
//  });